module.exports = __webpack_public_path__ + "static/header-icon-b-9b397dc544caa84360991d5017a2a402.png";